export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAILURE = "AUTH_FAILURE";
export const SET_PROFILE = "SET_PROFILE";
export const REMOVE_PROFILE = "REMOVE_PROFILE";

